// eslint-disable-next-line unicorn/prefer-node-protocol
import { parse } from 'url'

import { isEqual } from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'

import { captureMessage } from '@/utilities/sentryUtils'

const getPagePath = () => {
  const { path } = parse(window.location.href)
  return path
}
const doNotLogErrorsWithCode = new Set(['LOGOUT'])
const logErrors = (errors: any) => {
  const filteredErrors = errors.filter(({ code = 'E' }) => !doNotLogErrorsWithCode.has(code))

  if (filteredErrors.length > 0) {
    captureMessage(
      `Page error ${getPagePath()} [ ${errors
        .map(({ detailCode = 'ERR', code = 'E' }) => `${detailCode}-${code}`)
        .join(', ')} ]`
    )
  }
}
/**
 * Sends an error to sentry if it detects that errors have changed
 */
class ErrorEffect extends Component<any, any> {
  static displayName = 'ErrorEffect'

  static propTypes = {
    errors: PropTypes.array.isRequired
  }

  componentDidMount() {
    const { errors } = this.props

    logErrors(errors)
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps: any) {
    const { errors } = this.props

    if (!isEqual(errors, nextProps.errors)) {
      logErrors(errors)
    }
  }

  render() {
    return null
  }
}

export default ErrorEffect
